<template>
  <dialog v-if="lockedProfile" ref="dialogRef" class="profile-lock-dialog" @click="onBackdrop" @close="onDialogClose">
    <ProfileLock
      presentation="modal"
      :username="lockedProfile.username"
      :unlocks="lockedProfile.unlocks"
      :reason="lockedProfile.reason"
    />
  </dialog>
</template>

<script lang="ts" setup>
import { nextTick, onBeforeUnmount, ref, watch } from 'vue';
import ProfileLock from './ProfileLock.vue';
import { closeProfileLock, useProfileLock } from './profile-access';

const { lockedProfile } = useProfileLock();
const dialogRef = ref<HTMLDialogElement>();

watch(lockedProfile, async (profile) => {
  if (!profile) {
    if (dialogRef.value?.open) dialogRef.value.close();
    return;
  }

  await nextTick();
  dialogRef.value?.showModal();
});

onBeforeUnmount(() => {
  if (dialogRef.value?.open) dialogRef.value.close();
});

function onBackdrop(event: MouseEvent) {
  if (event.target === dialogRef.value) closeProfileLock();
}

function onDialogClose() {
  closeProfileLock();
}
</script>

<style lang="scss" scoped>
.profile-lock-dialog {
  width: 100%;
  height: 100%;
  border: 0;
  padding: var(--sai-top) var(--spacing-xl) var(--sai-bottom);
  margin: 0;
  max-width: 100%;
  max-height: 100%;
  background: transparent;
  display: flex;
  align-items: center;
  justify-content: center;
  outline: none;
  overflow: hidden;

  &::backdrop {
    background: rgba(23, 23, 23, 0.75);
  }
}
</style>
